import { lazy } from '../../shared/deployment';

export const JmeRedirect = lazy(() => import('./JmeRedirect'));
